import styles from "./ChartCard.module.css";

export const ChartCard = ({
  title,
  isLoading,
  isEmpty,
  emptyMessage = "No data for the selected filters",
  children,
}) => {
  return (
    <div className={styles.chartCard}>
      <h3 className={styles.title}>{title}</h3>
      <div className={styles.body}>
        {isLoading ? (
          <div className={styles.skeleton} />
        ) : isEmpty ? (
          <p className={styles.emptyMessage}>{emptyMessage}</p>
        ) : (
          children
        )}
      </div>
    </div>
  );
};
